export default "/_next/static/images/d6fa0e77aaf72298dafccc12f82ef9ef.jpg";